module.exports = __webpack_public_path__ + "img/8_kim_h.83202320.png";